import { InvoiceDocumentWithSummaryAndAmendments } from '@/api/services/invoices/searchInvoiceDocumentTable';
import { InvoiceHistoryTableProps } from '@/pages/InvoiceHistory/InvoiceHistoryTable';
import InvoiceHistoryTableRow from '@/pages/InvoiceHistory/InvoiceHistoryTable/InvoiceHistoryTableRow';
import Table from '@/common/Table';
import { getClasses } from '@/utils';
import { useState } from 'react';

export type InvoiceHistoryTableCollapsibleRowProps = {
  invoice: InvoiceDocumentWithSummaryAndAmendments;
  selected: string[];
  onSelect: InvoiceHistoryTableProps['onSelect'];
  openInvoice?: InvoiceHistoryTableProps['openInvoice'];
  onDownloadInvoice?: InvoiceHistoryTableProps['onDownloadInvoice'];
  onShowInvoiceActivity?: InvoiceHistoryTableProps['onShowInvoiceActivity'];
};

const InvoiceHistoryTableCollapsibleRow = ({
  invoice,
  selected,
  onSelect,
  openInvoice,
  onDownloadInvoice,
  onShowInvoiceActivity,
}: InvoiceHistoryTableCollapsibleRowProps): JSX.Element => {
  const [expanded, setExpanded] = useState(false);
  const numberOfAmendments = invoice?.history?.length;
  const amendedRows = invoice?.history?.map((invoice: InvoiceDocumentWithSummaryAndAmendments, index): JSX.Element => {
    return (
      <Table.Row
        key={invoice?.id}
        onDoubleClick={numberOfAmendments - 1 === 0 ? (): void => openInvoice?.(invoice.invoiceId) : undefined}
        className={getClasses(selected.includes(invoice?.invoiceId?.toString?.()) ? 'selected' : '')}
      >
        <InvoiceHistoryTableRow
          {...invoice}
          label={index === numberOfAmendments - 1 && 'original'}
          onSelect={onSelect}
          isSelected={selected.includes(invoice?.id?.toString?.())}
          onDownloadInvoice={onDownloadInvoice}
          onShowInvoiceActivity={onShowInvoiceActivity}
        />
      </Table.Row>
    );
  });

  return (
    <Table.Collapse
      in={expanded}
      onDoubleClick={(): void => openInvoice(invoice.invoiceId)}
      content={amendedRows.length > 0 ? <Table>{amendedRows}</Table> : undefined}
      className={getClasses(selected.includes(invoice?.id?.toString?.()) ? 'selected' : '', numberOfAmendments > 0 && 'amended')}
    >
      <InvoiceHistoryTableRow
        {...invoice}
        expanded={expanded}
        toggleExpanded={amendedRows.length > 0 ? () => setExpanded(!expanded) : undefined}
        label={numberOfAmendments > 0 ? 'most recent' : 'unamended'}
        onSelect={onSelect}
        isSelected={selected.includes(invoice?.invoiceId?.toString?.())}
        onDownloadInvoice={onDownloadInvoice}
        onShowInvoiceActivity={onShowInvoiceActivity}
      />
    </Table.Collapse>
  );
};

export default InvoiceHistoryTableCollapsibleRow;
